import { Route } from '@angular/router';
import { PrepareComponent } from './prepare.component';

export const PrepareRoutes: Route[] = [
  {
    path: 'prepare/:id',
    component: PrepareComponent
  },
  {
    path: 'template/:id',
    component: PrepareComponent
  }
];
